'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';

export type DividerLabelProps = {
  children: React.ReactNode;
  className?: string;
};

/**
 * Horizontal rule with a centered label — used as a visual section break
 * inside content areas and dialogs (e.g. "Then continue to", "or").
 */
export function DividerLabel({ children, className }: DividerLabelProps) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <span className="h-px flex-1 bg-border" aria-hidden />
      <span className="text-caption text-muted-foreground/50">
        {children}
      </span>
      <span className="h-px flex-1 bg-border" aria-hidden />
    </div>
  );
}
